export { default } from './ThemeProvider';
export { default as unstable_nested } from './nested';


//////////////////
// WEBPACK FOOTER
// ../@mui/private-theming/ThemeProvider/index.js
// module id = 828
// module chunks = 25